import type {CompleteHandler, RecurrentParams} from '@interfaces/PaymentPopup';
import type ValueList from '@interfaces/ValueList';

export default abstract class PopupBuilder {
    public abstract setRecurrentData(params: RecurrentParams): this;
    public abstract setCustomData(params: ValueList): this;
    public abstract setItem(description: string, price: number): this;
    public abstract setCompleteHandler(handler: CompleteHandler): this;
    public abstract buildCharge(): Promise<unknown>;
    public abstract buildAuth(): Promise<unknown>;
}
